import { environment } from '../../../environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const HrApiResources = {
  // get staff listing
  getStaffListing: createUrl('staff'),
  staffListingWithSearch: createUrl('staff/search'),

  //get Roles
  getRoles: createUrl('roles'),

  //get staff certificates
  getStaffCertificates: createUrl('staff-certificates/active'),

  //create staff
  createStaff: createUrl('staff/create'),

  //get language+timezone list
  getLanguageTimezone: createUrl('localization/listing'),

  //get saved localization defaults (used to auto-select default Time Zone on staff create)
  getLocalization: createUrl('localization'),

  //delete staff data
  deleteStaffData: createUrl('staff'),
  deleteMultiple: createUrl('hr/delete/multiple'),
  deleteAvailability: createUrl('hr/delete/availability'),

  //get single staff
  getSingleStaffData: createUrl('staff'),

  //get single staff
  updateStaffData: createUrl('staff'),

  //get Staff Statuses
  getStaffStatuses: createUrl('statuses/staff'),

  changeStaffStatus: createUrl('staff/change-status'),

  //put staff on hold / release from hold
  onHoldStaff: createUrl('staff/onhold'),

  //change staff password
  changeStaffPassword: createUrl('change-password'),
  // change staff password base
  changeStaffPasswordBase: createUrl('staff'),

  //get Staff Documents
  getStaffDocument: createUrl('staff/documents'),

  //get Roles
  getActiveDepartments: createUrl('department/active'),

  terminateStaff: createUrl('staff/terminate'),

  createProfileImage: createUrl('staff/upload/profile/image'),

  //work schedules
  createWorkSchedule: createUrl('work-schedules'),
  getWorkSchedule: createUrl('work-schedules'),

  //attendance clock in/out
  clockIn: createUrl('attendance/clock-in'),
  clockOut: createUrl('attendance/clock-out'),
  getClockStatus: createUrl('attendance/clock-status'),
  getWeeklyTimesheet: createUrl('attendance/weekly-timesheet'),

  //staff skill categories and names
  getStaffCategories: createUrl('staff-categories'),
  getSkillNamesByCategory: createUrl('staff-skill-names/category'),
  createStaffSkillQualification: createUrl('staff-skills-qualifications'),
  updateStaffSkillQualification: createUrl('staff-skills-qualifications'),
  getStaffSkillsQualifications: createUrl('staff-skills-qualifications'),

  //staff emergency contact
  createStaffContact: createUrl('staff-contact'),
  getStaffContact: createUrl('staff-contact'),
  updateStaffContact: createUrl('staff-contact'),
  deleteStaffContact: createUrl('staff-contact'),

  //staff safety training
  getStaffTrainingTypes: createUrl('staff-training-types'),
  createStaffTraining: createUrl('staff-trainings'),
  getStaffTrainings: createUrl('staff-trainings'),
  updateStaffTraining: createUrl('staff-trainings'),
  deleteStaffTraining: createUrl('staff-trainings'),

  //recent time entries
  getRecentTimeEntries: createUrl('attendance/recent-time-entries'),
  deleteTimeEntry: createUrl('attendance'),
  updateTimeEntry: createUrl('attendance'),

  //attendance overview
  getAttendanceOverview: createUrl('attendance/overview'),

  //time off requests (PTO)
  createTimeOffRequest: createUrl('time-off-requests'),
  getPTOApprovalQueue: createUrl('time-off-requests/approval-queue'),
  bulkUpdateTimeOffStatus: createUrl('time-off-requests/bulk-status'),
  getPTOPendingCount: createUrl('time-off-requests/pending/count'),
  getPTOBalance: createUrl('time-off-requests'),
  updatePTORequestStatus: createUrl('time-off-requests'),
  timeOffRequestDocuments: createUrl('time-off-requests'), // + /{id}/documents
  // Files are uploaded/deleted through the existing generic attachments endpoint
  // (same one Product's "Add Picture" uses) — not a dedicated upload route.
  uploadAttachment: createUrl('attachments'),

  //staff licenses & certificates
  getLicenseCertificateCategories: createUrl('staff/all/license-certificate-categories'),
  createStaffLicenseCertificate: createUrl('staff/certificate'),
  updateStaffLicenseCertificate: createUrl('staff/certificate'),
  deleteStaffLicenseCertificate: createUrl('staff/delete/certificate'),
  getAllStaffCertificates: createUrl('staff/all/certificates'),

  //staff rating
  updateStaffRating: createUrl('user'),
  getStaffRating: createUrl('user'),

  //user limit
  getUserLimit: createUrl('staff/user-limit'),
  getConcurrentUserLimit: createUrl('staff/concurrent-user-limit'),
};
